import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectEngagementMeasurementV2Domain = (state) =>
  state.get("engagementMeasurementV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectEngagementMeasurementV2Domain, (state) =>
    state.get("isLoading")
  )

export const makeSelectIsLoadingDimensionsData = () =>
  createSelector(selectEngagementMeasurementV2Domain, (state) =>
    state.get("isLoadingDimensionsData")
  )

export const makeSelectMeasureEngagement = () =>
  createSelector(selectEngagementMeasurementV2Domain, (state) =>
    state.get("measureEngagement")
  )

export const makeSelectDimensionsData = () =>
  createSelector(selectEngagementMeasurementV2Domain, (state) =>
    state.get("dimensionsData")
  )

export { selectEngagementMeasurementV2Domain }
